module.exports = __webpack_public_path__ + "img/bubbles.0e907ff3.svg";